import { FlatList } from "@/components/ui/flat-list";
import { WalletDTO } from "@/generated/api/models";
import {
  RestaurantWalletItemCreateMini,
  RestaurantWalletItemMini,
} from "./restaurant.wallet.item";
import { Spinner } from "@/components/ui/spinner";
import { VStack } from "@/components/ui/vstack";
import { useOrgWalletControllerList } from "@/generated/api/api";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { RestaurantWalletActionSheet } from "./restaurant.wallet.action.sheet";
import { Pressable } from "@/components/ui/pressable";

export type RestaurantWalletListMiniProps = {
  organizationId: string;
  onWalletListChanged?: (wallets?: WalletDTO[]) => void;
};

export type RestaurantWalletListMiniRef = {
  refresh: () => void;
};

export const RestaurantWalletListMini = forwardRef<
  RestaurantWalletListMiniRef,
  RestaurantWalletListMiniProps
>((props, ref) => {
  const {
    data: wallets,
    isLoading,
    refetch,
  } = useOrgWalletControllerList(props.organizationId);

  useEffect(() => {
    props.onWalletListChanged?.(wallets);
  }, [wallets]);

  useImperativeHandle(
    ref,
    () => ({
      refresh() {
        refetch();
      },
    }),
    []
  );

  const [sheetIsOpen, setSheetIsOpen] = useState(false);
  const [sheetWallet, setSheetWallet] = useState<WalletDTO>();

  return (
    <>
      <FlatList
        className="h-24 w-full"
        contentContainerClassName="grow gap-4"
        horizontal
        data={wallets?.slice(0, 5)}
        keyExtractor={(info) => info.id}
        renderItem={(info) => {
          return (
            <Pressable
              className="h-full w-36"
              onPress={() => {
                setSheetWallet(info.item);
                setSheetIsOpen(true);
              }}
            >
              <RestaurantWalletItemMini wallet={info.item} />
            </Pressable>
          );
        }}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        ListFooterComponent={() => (
          <RestaurantWalletItemCreateMini
            organizationId={props.organizationId}
          />
        )}
        ListEmptyComponent={() =>
          isLoading && (
            <VStack className="w-36 h-full justify-center p-3">
              <Spinner size="large" />
            </VStack>
          )
        }
      />
      <RestaurantWalletActionSheet
        wallet={sheetWallet}
        isOpen={sheetIsOpen}
        onClose={() => setSheetIsOpen(false)}
        organizationId={props.organizationId}
      />
    </>
  );
});
